export const cilFolder = ["24 24","<path d='M22.125 22.125h-20.25c-0.621-0.001-1.124-0.504-1.125-1.125v-18c0.001-0.621 0.504-1.124 1.125-1.125h8.75c0.001 0 0.001 0 0.002 0 0.465 0 0.863 0.282 1.034 0.685l0.003 0.007 0.961 2.308h9.5c0.621 0.001 1.124 0.504 1.125 1.125v15c-0.001 0.621-0.504 1.124-1.125 1.125h-0zM2.25 20.625h19.5v-14.25h-10.125l-1.25-3h-8.125z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-folder.js
// module id = null
// module chunks = 